import dispatcher from 'dispatcher';
import Api from 'utils/api';
import * as actionConstants from 'utils/ActionConstants';

export const resendWelcomeEmail = async () => {
    return await Api.resendWelcomeEmail();
};



// WEBPACK FOOTER //
// ./src/modules/email-confirmation/EmailConfirmationActions.js